
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojejurikhandolatemple() {



    const cardData =
    {
        keyword: 'Pune to Jejuri Khandoba Temple Cabs',
        heading: 'Platinum24 Cabs: Pune to Jejuri Khandoba Temple Cabs',
        headingDescription: ' Platinum24 Cabs provides convenient Pune to Jejuri Khandoba Temple Cabs, ensuring a safe and comfortable journey to the revered shrine of Lord Khandoba. Our fleet of hatchbacks, sedans, SUVs, and luxury cars offers reliable travel options for families, groups, and devotees visiting Jejuri for darshan. With professional chauffeurs, punctual pickups, and transparent pricing, we make your spiritual trip stress-free and comfortable. Whether you’re planning a same-day darshan or a weekend pilgrimage, Platinum24 Cabs guarantees affordable fares, 24/7 availability, and a peaceful travel experience from Pune to Jejuri Khandoba Temple.',

        top: 'Top Places to Visit in Jejuri Khandoba with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Khandoba Temple (Jejuri Gad)",
    "description": "The Khandoba Temple at Jejuri, located on a hilltop fort, is the most revered shrine dedicated to Lord Khandoba, considered an avatar of Lord Shiva. Devotees climb nearly 200 steps to reach the temple, which offers panoramic views of Jejuri town. The temple is famous for its ritual use of turmeric powder, symbolizing prosperity and blessings. During festivals like Champa Shashti, the temple is covered in a golden hue of turmeric. It is Maharashtra’s vibrant center of faith, devotion, and tradition."
  },
  {
    "title": "Turmeric Festival (Bhandara Festival)",
    "description": "The Bhandara Festival at Jejuri is a spectacular event where lakhs of devotees gather and throw turmeric powder in the air, turning the temple and surroundings golden. The sight is both spiritual and breathtaking, symbolizing blessings of fertility, prosperity, and victory. Devotees chant ‘Yelkot Yelkot Jai Malhar’ in praise of Khandoba. The festival attracts devotees from across Maharashtra. It is Jejuri’s signature celebration of devotion and joy."
  },
  {
    "title": "Fortification of Jejuri Gad",
    "description": "The Khandoba Temple is part of Jejuri Gad, an old hill fort with stone bastions, gateways, and ancient walls. Exploring the fort gives a glimpse into its military significance during the Maratha period. The climb to the temple is through stone steps lined with arches and small shrines. Pilgrims admire both the religious and historical aspects here. Jejuri Gad is Jejuri’s blend of heritage and spirituality."
  },
  {
    "title": "Deepmalas (Lamp Towers)",
    "description": "The temple complex of Jejuri is adorned with tall deepmalas (lamp towers) that glow with thousands of oil lamps during festivals. These lamp towers represent light conquering darkness and are central to temple rituals. Photographers and devotees find them visually captivating. They enhance the grandeur of evening aartis. The deepmalas make Jejuri one of the most picturesque pilgrim towns in Maharashtra."
  },
  {
    "title": "Karha River",
    "description": "The Karha River flows at the base of Jejuri and is considered holy by devotees of Lord Khandoba. Pilgrims take ritual baths here before climbing to the temple. The riverbanks are dotted with small shrines and ghats. During festivals, processions of palanquins cross the river, creating a spiritual atmosphere. The river adds natural beauty to the religious setting. Karha River is Jejuri’s sacred waterway of devotion."
  },
  {
    "title": "Champa Shashti Festival",
    "description": "Champa Shashti is the grand annual festival of Lord Khandoba, celebrated in Jejuri with immense devotion. The six-day festival marks the victory of Khandoba over demons Mani and Malla. The temple is decorated with turmeric, lamps, and flowers, and lakhs of devotees participate in rituals. Processions, bhajans, and cultural programs fill the air with devotion. Champa Shashti makes Jejuri the epicenter of Maharashtra’s warrior-God worship."
  },
  {
    "title": "Maratha History Connections",
    "description": "Jejuri holds great significance in Maratha history, as Lord Khandoba was regarded as the family deity of the Bhosale clan, including Chhatrapati Shivaji Maharaj. Historical references show Shivaji seeking blessings here before battles. The temple stands as a symbol of warrior spirit, protection, and victory. For history lovers, it connects religion with Maratha valor. Jejuri is Maharashtra’s sacred land of divine warriors."
  },
  {
    "title": "Mandap and Arches",
    "description": "The temple’s stone arches and mandaps on the way up to the shrine are beautifully carved and decorated. They serve as resting points for pilgrims climbing the steps. Many small shrines of deities and guardians line the path, adding to the spiritual experience. Turmeric-smeared pillars enhance the vibrant atmosphere. These arches make Jejuri’s approach as divine as the main temple."
  },
  {
    "title": "Palkhi Processions",
    "description": "Jejuri is famous for its palkhi processions where the idol of Lord Khandoba is carried in a palanquin, accompanied by drums, chants, and showers of turmeric. These processions occur during major festivals and yatras. Devotees walk barefoot, singing bhajans in praise of Malhari Martand. The energy and devotion are infectious, attracting lakhs of participants. Palkhis are Jejuri’s living tradition of collective worship."
  },
  {
    "title": "Local Markets of Jejuri",
    "description": "The bazaars around Jejuri temple are filled with stalls selling turmeric packets, souvenirs, toys, sweets, and pooja items. Pilgrims buy turmeric to offer to Lord Khandoba and also take it home as prasad. The vibrant market atmosphere adds to the festive charm. Traditional snacks like bhajis, laddus, and sugarcane juice are popular here. Jejuri’s local markets are both cultural and devotional extensions of the pilgrimage."
  }
],



      "services": [
    {
      "name": "Pune to Jejuri Khandoba Temple Taxi",
      "description": "Embark on a spiritual journey to the revered Jejuri Khandoba Temple with our reliable Pune to Jejuri taxi service. Enjoy comfortable, air-conditioned vehicles driven by experienced drivers who understand the importance of religious travel. Perfect for early morning or weekend darshan trips, this service ensures a peaceful ride, timely arrival, and doorstep pickup from any location in Pune."
    },
    {
      "name": "Jejuri Khandoba Temple Cab Booking Pune",
      "description": "Book a cab to Jejuri Khandoba Temple from Pune with ease through our online or phone booking system. We offer instant confirmations, flexible scheduling, and vehicle options ranging from hatchbacks to premium SUVs. Ideal for solo travelers, families, and pilgrimage groups heading to this sacred destination."
    },
    {
      "name": "Pune Jejuri Khandoba Temple Cabs",
      "description": "Choose from a range of Pune to Jejuri cabs for a devotional outing. Our cabs are clean, sanitized, and GPS-enabled for your safety and convenience. Whether you're going for a quick darshan or a full-day temple visit, our drivers ensure smooth travel across all routes and ghats leading to Jejuri."
    },
    {
      "name": "Taxi for Jejuri Khandoba Temple Pune",
      "description": "Dedicated taxi services for pilgrims visiting Jejuri’s Khandoba Temple from Pune. We offer vehicles with devotional music, temple information guides, and enough space for offerings and belongings. Drivers are respectful of temple visit timings and rituals."
    },
    {
      "name": "Pune to Jejuri Khandoba Temple Car Rental",
      "description": "Rent a car from Pune to Jejuri Khandoba Temple with or without a driver. Options include hourly rentals, full-day packages, and customized trip plans. Car types include economy, sedan, SUV, and luxury variants depending on your comfort and group size."
    },
    {
      "name": "Jejuri Khandoba Temple Pilgrimage Taxi Pune",
      "description": "A specialized taxi service designed for religious travel to Jejuri Khandoba Temple from Pune. We accommodate all types of pilgrims—families, senior citizens, devotees in groups—providing door-to-temple services with punctual pickups and clean, devotional-friendly cabs."
    },
    {
      "name": "Affordable Jejuri Khandoba Temple Tour Cabs Pune",
      "description": "Travel to Jejuri Khandoba Temple without breaking your budget. Our affordable cab services include transparent pricing, no hidden costs, and options to share or pool rides for reduced fares. Get more value with inclusive fuel, toll, and parking."
    },
    {
      "name": "Pune Jejuri Khandoba Temple Private Taxi",
      "description": "Enjoy privacy and comfort with a dedicated taxi from Pune to Jejuri. Our private taxis ensure no ride-sharing, flexible temple visit durations, and the ability to stop at scenic viewpoints or nearby shrines en route."
    },
    {
      "name": "Pune to Jejuri Khandoba Temple Taxi Fare",
      "description": "Check accurate and up-to-date taxi fare for Pune to Jejuri Khandoba Temple trips. Fare includes driver allowance, fuel, and tolls. Get fare estimates for round-trip, one-way, and custom travel packages with vehicle-wise comparison."
    },
    {
      "name": "Jejuri Khandoba Temple Taxi Packages Pune",
      "description": "Explore our taxi packages for Jejuri Khandoba Temple travel from Pune. Packages include round trips, multi-stop pilgrimages (e.g., Saswad or Prati Balaji), and complete day itineraries. Best suited for family groups or religious tours."
    },
    {
      "name": "Pune Jejuri Khandoba Temple One Way Taxi",
      "description": "Book a convenient one-way taxi from Pune to Jejuri Khandoba Temple. Pay only for the onward journey, perfect for devotees planning an extended stay or onward travel. Available across all car segments."
    },
    {
      "name": "Taxi Service Pune to Jejuri Khandoba Temple",
      "description": "24/7 taxi service available from Pune to Jejuri Khandoba Temple. Easy scheduling, verified drivers, and comfortable rides guaranteed. Avail last-minute bookings or pre-scheduled darshan trips with ease."
    },
    {
      "name": "Jejuri Khandoba Temple Taxi with Driver Pune",
      "description": "Hire a taxi with a professional driver from Pune to Jejuri Khandoba Temple. Our drivers are punctual, courteous, and knowledgeable about the temple region, ensuring a safe and respectful travel experience."
    },
    {
      "name": "Pune to Jejuri Khandoba Temple Cab Charges",
      "description": "Get a detailed breakdown of cab charges from Pune to Jejuri Khandoba Temple, including fuel costs, return charges (if applicable), and driver allowance. Transparent pricing and no hidden fees."
    },
    {
      "name": "Jejuri Khandoba Temple Cab Service Pune",
      "description": "Comprehensive cab service from Pune to Jejuri Temple tailored for individual pilgrims, families, and religious groups. Book AC/non-AC cabs with options for early morning temple access and customized return schedules."
    }
  ],
  "tableData": [
    ["Pune to Jejuri Khandoba Temple Taxi", "Jejuri Khandoba Temple Cab Booking Pune"],
    ["Pune Jejuri Khandoba Temple Cabs", "Taxi for Jejuri Khandoba Temple Pune"],
    ["Pune to Jejuri Khandoba Temple Car Rental", "Jejuri Khandoba Temple Pilgrimage Taxi Pune"],
    ["Affordable Jejuri Khandoba Temple Tour Cabs Pune", "Pune Jejuri Khandoba Temple Private Taxi"],
    ["Pune to Jejuri Khandoba Temple Taxi Fare", "Jejuri Khandoba Temple Taxi Packages Pune"],
    ["Pune Jejuri Khandoba Temple One Way Taxi", "Taxi Service Pune to Jejuri Khandoba Temple"],
    ["Jejuri Khandoba Temple Taxi with Driver Pune", "Pune to Jejuri Khandoba Temple Cab Charges"],
    ["Jejuri Khandoba Temple Cab Service Pune", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Jejuri Khandoba Temple Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs provides comfortable and trustworthy rides from Pune to Jejuri Khandoba Temple for a smooth pilgrimage."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Jejuri Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure timely and safe travel."
    },
    {
      "WhyChooseheading": "Spacious and Sanitized Vehicles for Comfortable Travel",
      "WhyChoosedescription": "Travel in clean, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages that suit your pilgrimage schedule and preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances for a hassle-free journey."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Bookings",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist with your booking needs and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Family and Group Pilgrimages",
      "WhyChoosedescription": "Our Pune to Jejuri Khandoba Temple cabs are perfect for all travelers seeking a spiritual experience."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your travel needs."
    }
  ]





































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Jejuri Khandoba Temple?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel from Pune to Jejuri Khandoba Temple.',
    },
    {
        question: 'How can I book a Pune to Jejuri cab with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24/7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Jejuri Khandoba Temple trips?',
        answer: 'We provide a wide range of vehicles including sedans, SUVs, and tempo travellers to match your group size and travel comfort.',
    },
    {
        question: 'Are your drivers experienced with the Pune to Jejuri route?',
        answer: 'Yes, our drivers are highly experienced and familiar with the Pune to Jejuri route and local temple timings.',
    },
    {
        question: 'Is round-trip booking available from Pune to Jejuri?',
        answer: 'Yes, we offer both one-way and round-trip cab options with flexible pickup and return schedules.',
    },
    {
        question: 'What is included in the fare for Pune to Jejuri Khandoba Temple cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Extra charges may apply for additional stops or extended waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off points for Jejuri trips?',
        answer: 'Absolutely! You can choose custom pickup and drop-off locations within Pune and surrounding areas.',
    },
    {
        question: 'Are safety and hygiene maintained during Jejuri cab rides?',
        answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow all hygiene and safety protocols for your peace of mind.',
    },
    {
        question: 'Is there an option to book a cab for a full-day pilgrimage tour including Jejuri?',
        answer: 'Yes, we offer full-day and multi-temple tour packages which can include Jejuri and nearby religious sites.',
    },
    {
        question: 'Does Platinum24 Cabs provide group or corporate travel to Jejuri Khandoba Temple?',
        answer: 'Yes, we offer tailored group and corporate travel solutions including tempo travellers and minibus rentals for Jejuri trips.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Shrikant Jagtap',
        feedback: 'Our visit to Jejuri Khandoba Temple with Platinum24 Cabs was seamless. The cab was clean, and the driver was punctual and respectful.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Mrs. Rekha Dhumal',
        feedback: 'Very professional service from Pune to Jejuri. The booking was easy and the overall journey was extremely comfortable.',
        rating: 5,
    },
];














































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToJejuriKhandobaSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jejuri Khandoba Temple Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-jejuri-khandoba-temple-cab.jpg",
  "description": "Book Pune to Jejuri Khandoba Temple taxi services with Platinum24 Cabs. Comfortable, reliable, and affordable cabs for your pilgrimage with professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-jejuri-khandoba-temple-cab"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune to Jejuri Khandoba Temple Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Jejuri Khandoba Temple taxi service with Platinum24 Cabs. Affordable pilgrimage cabs with professional drivers for comfortable travel."
  />
  <meta
    name="keywords"
    content="Pune to Jejuri Khandoba Temple Taxi, Jejuri Khandoba Temple Cab Booking Pune, Pune Jejuri Khandoba Temple Cabs, Taxi for Jejuri Khandoba Temple Pune, Pune to Jejuri Khandoba Temple Car Rental, Jejuri Khandoba Temple Pilgrimage Taxi Pune, Affordable Jejuri Khandoba Temple Tour Cabs Pune, Pune Jejuri Khandoba Temple Private Taxi, Pune to Jejuri Khandoba Temple Taxi Fare, Jejuri Khandoba Temple Taxi Packages Pune, Pune Jejuri Khandoba Temple One Way Taxi, Taxi Service Pune to Jejuri Khandoba Temple, Jejuri Khandoba Temple Taxi with Driver Pune, Pune to Jejuri Khandoba Temple Cab Charges, Jejuri Khandoba Temple Cab Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToJejuriKhandobaSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojejurikhandolatemple;